export default "__VITE_ASSET__BoynwOkA__"